import React from 'react';
import BaseSubmitButton from 'components/quote_builder_widget/shared/SubmitButton';

const SubmitButton = ({ buttonState, onClick }) => {
  return (
    <div className="mb-3 mt-3" data-widget-element="form-group">
      <BaseSubmitButton
        buttonState={buttonState}
        onClick={onClick}
        buttonClassName="btn btn-primary w-100"
      />
    </div>
  );
};

export default SubmitButton;
